import React, {useEffect} from 'react'
import AdmissionSection from '../../components/AdmissionComponents/AdmissionSection/AdmissionSection'
import Footer from '../../components/Footer/Footer'
import './Admissions.scss'
import { Link, useLocation } from 'react-router-dom'

const AdmissionPage = () => {
  const location = useLocation()

  // Scroll to the top when the page is mounted or the location changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div>
        
        <AdmissionSection />
        <Footer />
    </div>
  )
}

export default AdmissionPage